export default __webpack_public_path__ + "static/media/790246002584977418.1fa9a5d9.png";